import * as types from './mutation-types';

export default {
  [types.SET_RETENCIONES] (state, retenciones) {
    state.retenciones = retenciones;
  }
}
